import { ApplicationRef, inject, Injectable } from '@angular/core';
import { concat, first, interval } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class ServiceWorkerUpdateService {
  private appRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate);
  private versionCheckIntervalSeconds = 5 * 60;
  private updateReadyToInstall = false;

  constructor() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.info(
            `New application version found, Downloading new app version: ${evt.version.hash}`
          );
          this.updateReadyToInstall = false;
          break;
        case 'VERSION_READY':
          console.info(
            `New app version ready for use: ${evt.latestVersion.hash} vs Current app version: ${evt.currentVersion.hash}`
          );
          this.updateReadyToInstall = true;
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.error(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          this.updateReadyToInstall = false;
          break;
      }
    });

    // If service worker detects app is broken
    this.swUpdate.unrecoverable.subscribe(event => {
      console.error(
        'An error occurred that we cannot recover from:\n' +
          event.reason +
          '\n\nPlease reload the page.'
      );
      document.location.reload();
    });
  }

  public init() {
    this.watchForUpdates();
  }

  watchForUpdates() {
    if (!this.swUpdate.isEnabled) return;

    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const everyFiveMinutes$ = interval(this.versionCheckIntervalSeconds * 1000);
    const everyFiveMinutesOnceAppIsStable$ = concat(appIsStable$, everyFiveMinutes$);
    everyFiveMinutesOnceAppIsStable$.subscribe(async () => {
      try {
        console.log('SWUpdate Check for update');
        const updateFound = await this.swUpdate.checkForUpdate();
        console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });
  }

  applyUpdate() {
    if (this.updateReadyToInstall) {
      document.location.reload();
    }
  }
}
